require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var errors_1 = require("./utilities/errors");

var parsePoints_1 = require("./operators/parsePoints");

var constants_1 = require("./constants");

var selectorRegex = /^([#|\.]|path)/i;

function convertToPathData(pathSource) {
  if (Array.isArray(pathSource)) {
    return {
      data: pathSource,
      stringData: constants_1._
    };
  }

  var stringData;

  if (typeof pathSource === 'string' && selectorRegex.test(pathSource)) {
    pathSource = document.querySelector(pathSource);
  } else {
    stringData = pathSource;
  }

  if (typeof pathSource === 'string') {
    return {
      data: parsePoints_1.parsePoints(pathSource),
      stringData: stringData
    };
  }

  var pathElement = pathSource;

  if (pathElement.tagName.toUpperCase() === 'PATH') {
    stringData = pathElement.getAttribute('d');
    return {
      data: parsePoints_1.parsePoints(stringData),
      stringData: stringData
    };
  }

  return errors_1.raiseError('Unsupported element ', pathElement.tagName);
}

exports.convertToPathData = convertToPathData;